import { ConnectionDetails } from '../../store';

const WEBSOCKET_PORT = 8001;
const WEBSOCKET_PATH = `ws://localhost:${WEBSOCKET_PORT}`;
interface BaseWSClientMsg {
  domain: string; // Where this command is intended to go (i.e. SSH Another computer, This docker container...)
  cmd: string; // Command to switch against
  payload: any;
}

export interface ResponseMessage {
  error: BaseWSErrorMsg;
  payload?: any;
}

export interface BaseWSErrorMsg {
  isError: boolean;
  errorCode: number;
  errorMsg: string;
}

export class SSHMessage {
  data: string;
  constructor(data: string) {
    this.data = data;
  }
  toMessage() {
    return {
      command: 'write',
      data: this.data
    };
  }
}

/**
 * Strategy pattern for sending and responding to ssh messages
 */
export interface ConnectionStrategy {
  processMessage(
    connection: WebsocketSSHConnection,
    message: ResponseMessage
  ): void;

  getFirstMessage(): SSHMessage | null;
}

class InitialConnectionStrategy implements ConnectionStrategy {
  processMessage(
    connection: WebsocketSSHConnection,
    message: ResponseMessage
  ): void {
    if (!message.error.isError) {
      connection.setStatus('connected');
    } else if (message.error.isError) {
      connection.setStatus(
        'Connection failed. Check SSH details.' + message.error.errorMsg
      );
    }
  }
  getFirstMessage() {
    return null;
  }
}

export class IdleConnectionStrategy implements ConnectionStrategy {
  processMessage(
    connection: WebsocketSSHConnection,
    message: ResponseMessage
  ): void {
    console.log(message);
  }
  getFirstMessage(): SSHMessage | null {
    return null;
  }
}

export class WebsocketSSHConnection {
  websocket: WebSocket;
  updateStatus: (status: string) => void = (status: string) => {};
  connectionStatus: string = 'disconnected';
  connectionStrategy: ConnectionStrategy = new InitialConnectionStrategy();
  pingTimeout: number = 5000;
  ping: boolean = true;
  connectionDetails: ConnectionDetails;
  password: string;
  constructor(connectionDetails: ConnectionDetails, password: string) {
    this.connectionDetails = connectionDetails;
    this.password = password;
    this.websocket = new WebSocket(WEBSOCKET_PATH);
    this.websocket.onerror = (event: Event) => {
      this.setStatus('websocket connection failed');
    };
    const connectCommand = {
      command: 'connect',
      hostname: connectionDetails.hostname,
      port: connectionDetails.port,
      username: connectionDetails.username,
      password: password
    };

    this.websocket.onmessage = (msg: MessageEvent<string>) => {
      // remove any carriage returns as they cause errors
      let msgData: ResponseMessage = JSON.parse(msg.data.replace('\r', ''));
      console.log(`message received: ${msg.data}`);
      this.connectionStrategy.processMessage(this, msgData);
      // }
    };
    this.websocket.onopen = (ev: Event) => {
      this.sendMessage(connectCommand);
    };
  }
  setStrategy(strategy: ConnectionStrategy) {
    this.connectionStrategy = strategy;
    let firstMessage = this.connectionStrategy.getFirstMessage();
    if (firstMessage) {
      this.sendMessage(firstMessage.toMessage());
    }
  }

  disconnect() {
    this.sendMessage({
      command: 'disconnect'
    });
  }
  /**
   * Converts the message to a JSON string and sends via websocket
   * @param message - JSON compatible object
   * @param type - denotes how the ssh tool will process the command
   * examples include 'output', which processes the command and returns
   * the output. can be: 'output', 'subsystem'
   */
  sendMessage(
    message: { command: string; data?: string },
    type: string = 'output',
    domain: string = 'ssh'
  ) {
    const toSend: BaseWSClientMsg = {
      cmd: message.command,
      domain: domain,
      payload: {
        data: message.data ? message.data : '',
        port: this.connectionDetails.port,
        hostname: this.connectionDetails.hostname,
        username: this.connectionDetails.username,
        password: this.password,
        type: type
      }
    };
    console.log(`sending message: ${JSON.stringify(toSend)}`);
    this.websocket.send(JSON.stringify(toSend));
  }

  /** Sets the status and calls the editable updateStatus function */
  setStatus(status: string) {
    this.updateStatus(status);
    this.connectionStatus = status;
  }
}
